import {
  createQueryAtomFactory,
  QueryAtomResult,
} from '~/shared/providers/api/createQueryAtomFactory';

export type ComplianceCheckRecord = QueryAtomResult<
  typeof complianceChecksQueryAtom
>[number];

export const complianceChecksQueryAtom = createQueryAtomFactory(
  'trade.complianceChecks',
  (params: { purchaseLoadId: string }) => ({
    complianceChecks: {
      __args: {
        filter: { purchaseLoadId: params.purchaseLoadId },
        sorting: ['CheckedAtDesc' as const],
        pagination: { offset: 0, limit: 50 },
      },
      entries: {
        id: true,
        purchaseLoadId: true,
        accountId: true,
        status: true,
        checkedAt: true,
        checkedByUserId: true,
        overrideReason: true,
        overriddenByUserId: true,
        overriddenAt: true,
        results: true,
        notes: true,
        timestamps: {
          createdAt: true,
          updatedAt: true,
        },
      },
    },
  }),
  {
    select: (data) => {
      if (!data) return [];
      return (data.complianceChecks?.entries ?? []).map((entry) => ({
        id: entry.id,
        purchaseLoadId: entry.purchaseLoadId,
        accountId: entry.accountId ?? null,
        status: entry.status,
        checkedAt: entry.checkedAt,
        checkedByUserId: entry.checkedByUserId ?? null,
        overrideReason: entry.overrideReason ?? null,
        overriddenByUserId: entry.overriddenByUserId ?? null,
        overriddenAt: entry.overriddenAt ?? null,
        results: (entry.results as Record<string, unknown>) ?? null,
        notes: entry.notes ?? null,
        createdAt: entry.timestamps.createdAt,
        updatedAt: entry.timestamps.updatedAt,
      }));
    },
  },
);
